import React from 'react'
import {FlagAUIcon, FlagUSIcon} from '../../components/icons'

export const flags = {
    AU: <FlagAUIcon width={'2rem'} height={'2rem'} />,
    US: <FlagUSIcon width={'2rem'} height={'2rem'} />
}

export const zipCodeMsg = {
    US: '07001',
    CA: 'H0H 0H0'
}

export const nameRegex = /^[a-zA-Z]+$/
export const addressRegex = /^[a-zA-Z0-9\s,.'-]+$/
export const cityRegex = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/
export const ca_PostalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
export const zipCodeRegex = /^\d{5}(-\d{4})?$/
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
